<template>
    <div class="menu-trigger" @click="toggleMenu">
        <font-awesome-icon :icon="menuIcon" />
    </div>
</template>

<script>
    import { faTimes }  from '@fortawesome/pro-regular-svg-icons/faTimes'
    import { faBars }  from '@fortawesome/pro-regular-svg-icons/faBars'

    export default {
        name: "MobileMenuButton",
        props: {
            menuOpen: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            menuIcon() {
                return this.menuOpen ? faTimes:faBars
            }
        },
        methods: {
            toggleMenu() {
                this.$emit('toggleMenu')
            }
        }
    }
</script>

<style lang="scss" scoped>

    .menu-trigger {
        z-index: 999;
        margin-left: 20px;
        width: 65px;
        height: 65px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $white;
        @include orange-hover;
        font-size: 21px;
    }

</style>